import { Alert, AlertOctagonIcon, Box, Heading, Link } from '@razorpay/blade/components';
import React from 'react';
import { useQuery } from 'react-query';
import api from 'api';
import { GET_LOAN_SETTINGS, LIST_LOAN_CATEGORIES } from './constants';
import { EmployeeLoansSettingsSectionListItem } from './EmployeeLoansSettingsSectionListItem';
import { EmployeeLoansSettingsSectionProps } from './types';

export const EmployeeLoansSettingsSection = ({
  orgId,
  editLink,
  isReArchEmployeeLoansEnabled,
}: EmployeeLoansSettingsSectionProps) => {
  const { data: loanSettings, isError: loanSettingError } = useQuery({
    queryKey: GET_LOAN_SETTINGS,
    queryFn: api.loans.getLoanSettings,
  });

  const { data: loanCategoriesData, isError: categoriesError } = useQuery({
    queryKey: LIST_LOAN_CATEGORIES,
    queryFn: () => api.loans.listLoanCategories(),
  });

  const employeeRequestsValue = loanSettings?.is_loan_requests_enabled ? 'Enabled' : 'Disabled';
  const categoriesValue = loanCategoriesData?.data?.length
    ? loanCategoriesData.data.map((c) => c.name).join(', ')
    : '-';

  return (
    <Box marginBottom={'spacing.10'}>
      {loanSettingError || categoriesError ? (
        <Alert
          color="negative"
          description="Failed to load loan settings. Please try again later."
          emphasis="subtle"
          isDismissible={false}
          isFullWidth
          icon={AlertOctagonIcon}
        />
      ) : (
        <>
          <Box
            paddingBottom="spacing.4"
            display="flex"
            justifyContent="space-between"
            paddingLeft={'spacing.0'}>
            <Heading weight="semibold" size="medium" color="surface.text.gray.normal">
              Loans & Advances
            </Heading>
            <Link href={editLink}>Edit</Link>
          </Box>
          <Box
            display={'flex'}
            flexDirection={'column'}
            backgroundColor={'surface.background.gray.intense'}
            paddingY={'spacing.3'}
            paddingX={'spacing.0'}
            width="100%"
            borderColor="surface.border.gray.subtle"
            borderWidth="thin">
            <EmployeeLoansSettingsSectionListItem
              label="Employee Requests"
              value={employeeRequestsValue}
            />
            <EmployeeLoansSettingsSectionListItem
              label="Categories"
              value={categoriesValue}
              shouldHaveBorderBottom={false}
            />
          </Box>
        </>
      )}
    </Box>
  );
};
